import { colors } from '@alixpartners/ui-components';
import React from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	padding: 32px 40px;
`;

export const ScrollContainer = styled.div`
	height: 100%;
	overflow: auto;
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
`;

export const SectionWrapper = styled.div`
	margin-bottom: 26px;
`;

export const SectionContent = styled.div`
	#downloadButton {
		margin: 10px 0 0 0;
	}
`;

export const SectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
`;

export const Title = styled.div`
	color: #1a1a1a;
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
`;

export const FormSummary = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const FormSummaryLine = styled.tr`
	text-align: left;
`;

export const FormSummaryLabel = styled.td`
	color: ${colors.grey500};
	font-size: 16px;
	line-height: 32px;
	text-transform: capitalize;
	font-weight: normal;
	padding: 3px 30px 3px 0;
`;

export const FormSummaryValue = styled.td`
	color: ${colors.black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 5px 0;
	.options_wrapper {
		display: flex;
		gap: 10px;
	}
	.dropdown_selection {
		button {
			border: 1px solid ${colors.grey200};
		}
	}
	.sku_wrapper {
		display: flex;
		flex-direction: column;
	}
`;

export const DateRangeWrapper = styled.div``;

export const SKUTitle = styled.div`
	font-size: 12px;
	font-weight: 400;
	color: ${colors.grey400};
`;

export const CommodityTitle = styled.div`
	font-size: 12px;
	font-weight: 400;
	color: ${colors.grey400};
`;

export const SKUWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const CommodityWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const NoteWrapper = styled.div`
	margin-top: 10px;
	font-size: 12px;
	font-weight: 400;
	color: ${colors.grey400};
`;
